import { getRawPropertyData } from 'models/Cropwise';
import { useState, useEffect } from 'react';

export const useFarms = (orgId: string) => {
  const [farms, setFarms] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchFarms = async () => {
      if (!orgId) return;

      try {
        setLoading(true);
        setError(null);
        let fetchedFarms = await getRawPropertyData(orgId);

        if (!fetchedFarms) fetchedFarms = [];

        fetchedFarms.sort(({ name: name1 }: any, { name: name2 }: any) => (name1 > name2 ? 1 : -1));

        setFarms(fetchedFarms);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Failed to fetch farms'));
        console.error('Error fetching farms:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchFarms();
  }, [orgId]);

  return { farms, loading, error };
};
